import _ from 'lodash';
import {capitalize, N} from "../../../helpers";
import {PAYMENT_STATUS, RECEIPT_STATUS} from '../../../constants'

function getPayments(state) {
  let payments = state.cart.payments || [];

  payments = _.map((payments || [false]), (p) => {

    if(p.details){

      //Biller name
      if(p.details.biller_name){
        p.name = capitalize(p.details.biller_name)
      }

    }

    return p
  });

  return _.groupBy(payments, 'customer_mobile_number');
}

function getTotalAmount(state) {
  let payments = state.cart.payments || [];

  return _.reduce(payments, (sum, val) => {
    if(val.payment_status !== PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING || !val.payment_selected) return sum;
    return sum + val.requested_amount
  }, 0)
}

function getChangeAmount(state) {
  const totalAmount = getTotalAmount(state);
  const receivedAmount = state.cart.received_amount;

  if(!totalAmount) return 0;

  return receivedAmount - totalAmount
}

function havePaymentInProcessing(state) {
  let payments = state.cart.payments || [];

  return !!(_.find(payments, (p) => p.payment_status === PAYMENT_STATUS.PAYMENT_IN_PROCESSING));
}

function showGeneralReceiptButton(state) {
  return (state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_IN_PROCESSING ||
    state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_SUCCESS ||
    state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_FAIL
  )
}

function showGeneralReceiptButtonLoading(state) {
  return state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_IN_PROCESSING
}

function showGeneralReceiptButtonSuccess(state) {
  return state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_SUCCESS
}

function showGeneralReceiptButtonFail(state) {
  return state.cart.receipt_status === RECEIPT_STATUS.RECEIPT_FAIL
}


export {
  getPayments,
  getTotalAmount,
  getChangeAmount,
  havePaymentInProcessing,
  showGeneralReceiptButton,
  showGeneralReceiptButtonLoading,
  showGeneralReceiptButtonSuccess,
  showGeneralReceiptButtonFail
}


// WEBPACK FOOTER //
// ./src/components/ShoppingCart/containers/selectors.js